import React from 'react';
import { observer } from 'mobx-react';

import './pending-prescription-fill-style.scss';


const PendingVideoConferenceNotification = ({ prescriptionFill, onClick }) => (
  <div key={prescriptionFill.id} className='c-PendingPrescriptionFillNotification' onClick={() => onClick(prescriptionFill.id)}>
    <div className='patient-name'>
      {`${prescriptionFill.prescription.patient.firstName} ${prescriptionFill.prescription.patient.lastName}`}
    </div>
    <div className='drug-name'>
      {`${prescriptionFill.prescription.drug.name}`}
    </div>
  </div>
);

export default observer(PendingVideoConferenceNotification);
